import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const MinusCircleIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_1313_3558)"><path d="M10.8984 6C10.8984 4.70085 10.3823 3.45501 9.46362 2.53638C8.54499 1.61774 7.29915 1.10156 6 1.10156C4.70085 1.10156 3.45501 1.61774 2.53638 2.53638C1.61774 3.45501 1.10156 4.70085 1.10156 6C1.10156 7.29915 1.61774 8.54499 2.53638 9.46362C3.45501 10.3823 4.70085 10.8984 6 10.8984C7.29915 10.8984 8.54499 10.3823 9.46362 9.46362C10.3823 8.54499 10.8984 7.29915 10.8984 6ZM11.6484 6C11.6484 7.49806 11.0532 8.93461 9.9939 9.9939C8.93461 11.0532 7.49806 11.6484 6 11.6484C4.50194 11.6484 3.06539 11.0532 2.0061 9.9939C0.946816 8.93461 0.351562 7.49806 0.351562 6C0.351562 4.50194 0.946816 3.06539 2.0061 2.0061C3.06539 0.946816 4.50194 0.351562 6 0.351562C7.49806 0.351562 8.93461 0.946816 9.9939 2.0061C11.0532 3.06539 11.6484 4.50194 11.6484 6Z" fill="currentColor" /><path d="M8.69531 5.625C8.90242 5.625 9.07031 5.79289 9.07031 6C9.07031 6.20711 8.90242 6.375 8.69531 6.375H3.30469C3.09758 6.375 2.92969 6.20711 2.92969 6C2.92969 5.79289 3.09758 5.625 3.30469 5.625H8.69531Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default MinusCircleIcon;